import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollableContainer } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { useCallback } from 'react';
import { MediaService } from '../../../services/media/MediaService';
import { StreamrAppService } from '../../../services/streamrapp/StreamrAppService';
import { BottomCenter, Popup, TopCenter } from '../../../utils/popups';
import { DeviceSelector, DeviceSelectorContainer, DeviceSelectorPopupRoot, } from './DeviceSelectorPopup';
export const AddMicrophoneSelectorPopup = ({ reject, resolve, variant, ...props }) => {
    const audioDevices = MediaService.getOutput().useAudioDevices();
    const hasPermission = MediaService.getOutput().useMicrophonePermissioned();
    const onDeviceSelect = useCallback((device) => {
        StreamrAppService.getNotificationInterface().notifyAddMicrophone(device.deviceId);
        resolve();
    }, [resolve]);
    const onAllowAccess = useCallback(() => {
        MediaService.getNotificationInterface().notifyMediaPermissionsRequested({ audio: true });
        resolve();
    }, [resolve]);
    const translateFn = variant === 'top-center' ? TopCenter : BottomCenter;
    return (_jsx(DeviceSelectorPopupRoot, { className: variant, reject: reject, translateFn: translateFn, ...props, children: _jsx(ScrollableContainer, { children: _jsx(DeviceSelectorContainer, { children: _jsx(DeviceSelector, { label: "Add microphone", devicesList: audioDevices, selectedDevice: undefined, onDeviceSelect: onDeviceSelect, isEnabled: true, onEnableChange: () => { }, onClose: reject, hasAccessToDevices: hasPermission, onAllowAccess: onAllowAccess }) }) }) }));
};
const addMicrophonePopup = Popup.create(AddMicrophoneSelectorPopup);
export function selectAddMicrophone(options) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await addMicrophonePopup.pop({
                anchorRef: options.anchorRef,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
